import { ReactComponent as Logo } from "../assets/logos/appara_logo.svg";
import { CustomLink } from "../components";
import { useNavigate } from "react-router-dom";

import styles from "./styles/footer.module.scss";
import Strings from "../strings/strings";

export const FooterSection = (className: React.HTMLAttributes<HTMLDivElement>) => {
  const navigate = useNavigate();

  return (
    <>
      <div {...className}>
        <div className={styles.wrapper}>
          <div className={styles.info}>
            <div className={styles.logo}>
              <Logo />
            </div>
            <div className={styles.infoItem}>
              <span className={styles.title}>{Strings.footerSocialsTitle}</span>
              {CustomLink(
                "https://www.linkedin.com/company/appara-technologies-limited/?viewAsMember=true",
                Strings.footerLinkedIn,
                "white"
              )}
              {CustomLink("https://www.instagram.com/tryappara/", Strings.footerInstagram, "white")}
            </div>
            <div className={styles.infoItem}>
              <span className={styles.title}>{Strings.footerOurProducts}</span>
              <div className={styles.link} onClick={() => navigate("/calculator")}>
                {Strings.footerCalculator}
              </div>
            </div>
            <div className={styles.infoItem}>
              <span className={styles.title}>{Strings.footerContacts}</span>
              <div className={styles.link} onClick={() => navigate("/products")}>
                {Strings.footerInquiry}
              </div>
              <div className={styles.link} onClick={() => navigate("/products")}>
                {Strings.footerMeeting}
              </div>
              <div className={styles.link} onClick={() => navigate("/products")}>
                {Strings.footerConsult}
              </div>
            </div>
            <div className={styles.infoItem}>
              <span className={styles.title}>{Strings.footerOther}</span>
              <div className={styles.link} onClick={() => navigate("/termsConditions")}>
                {Strings.footerTnC}
              </div>
            </div>
          </div>
        </div>
      </div>
      )
    </>
  );
};
